import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { Card, CardActionArea, CardContent } from '@material-ui/core';
import PosterDialog from './PosterDialog';

import Chip from '@mui/material/Chip';
import FacultyDetail from '../faculty/FacultyDetail';

import axios from 'axios';
import { EVENT_ID, FACULTY_API_URL } from '../constants';

const styles = (theme) => ({
  posterCard: {
    marginBottom: '10px',
    boxShadow: 'none',
    backgroundColor: '#f9f9f9',
    border: 'solid 3px #f4f4f4',
    borderRadius: '10px',
    '&:hover': {
      border: '3px solid',
      borderColor: theme.palette.primary.main,
      backgroundColor: '#eaeff5',
      '& span': {
        color: theme.palette.primary.main,
      },
    },
    '&:focus': {
      border: '3px solid #4483ca',
      backgroundColor: '#eaeff5',
      '& span': {
        color: theme.palette.primary.main,
      },
    },
  },
  posterRegNo: {
    [theme.breakpoints.down('sm')]: {
      color: theme.palette.primary.main,
    },
  },
  posterTitle: {
    [theme.breakpoints.down('sm')]: {
      color: theme.palette.primary.main,
    },
  },
});

class PosterItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDialogOpen: false,
      isFacultyDialogOpen: false,
    };
  }

  dialogOpen = (event) => {
    this.setState({ isDialogOpen: true });
  };

  dialogClose = (event) => {
    this.setState({ isDialogOpen: false });
  };

  goFaculty = () => {
    if (this.props.data) {
      axios
        .get(`${FACULTY_API_URL}/faculty/info?eventId=${EVENT_ID}&id=${EVENT_ID}_${this.props.data.email}`)
        .then((response) => {
          if (response.data && response.data.Item) {
            this.setState({ facultyInfo: response.data.Item, isFacultyDialogOpen: true });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <>
        <Card className={classes.posterCard}>
          <CardActionArea onClick={this.dialogOpen}>
            <CardContent>
              <Grid container>
                <Grid container alignItems="center" item xs={12} md={3}>
                  <Grid>
                    <span style={{ fontWeight: 'bold', fontStyle: 'normal', wordBreak: 'break-all' }} className={classes.posterRegNo}>
                      {this.props.regNo}
                    </span>
                  </Grid>
                  <Grid>
                    {this.props.keyword1 && (
                      <Chip
                        label={this.props.keyword1}
                        style={{ color: '#fff', marginLeft: '10px', fontWeight: 'bold', backgroundColor: '#08d8a0' }}
                      />
                    )}
                    {/* {this.props.keyword2 && <Chip label={this.props.keyword2} style={{ marginLeft: '10px', fontWeight: 'bold' }} />} */}
                  </Grid>
                </Grid>
                <Grid item xs={12} md={9}>
                  <div
                    // onClick={() => this.goFaculty()}
                    style={{
                      display: 'flex',
                      justifyContent: 'left',
                      margin: '8px 0',
                      fontWeight: 'bold',
                      fontStyle: 'normal',
                      color: '#7e7e7e',
                    }}
                  >
                    {this.props.presenter}&nbsp;&nbsp;(&nbsp;{this.props.position.replace('^&^', ',')}&nbsp;,&nbsp;{this.props.country}
                    &nbsp;)
                  </div>
                  <div
                    style={{ display: 'flex', justifyContent: 'left', fontWeight: 'bold', fontStyle: 'italic' }}
                    className={classes.posterTitle}
                  >
                    {this.props.ptTitle}
                  </div>
                </Grid>
              </Grid>
            </CardContent>
          </CardActionArea>
        </Card>
        <PosterDialog
          open={this.state.isDialogOpen}
          // onClose={this.dialogClose}
          // disableBackdrop={false}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ isDialogOpen: false });
            }
          }}
          regNo={this.props.regNo}
          presenter={this.props.presenter}
          position={this.props.position}
          ptTitle={this.props.ptTitle}
          posterImg={this.props.posterImg}
          dept={this.props.dept}
          country={this.props.country}
        />

        {/* Faculty Dialog */}
        <FacultyDetail
          onClose={(event, reason) => {
            if (reason !== 'backdropClick') {
              this.setState({ isFacultyDialogOpen: false });
            }
          }}
          open={this.state.isFacultyDialogOpen}
          selectedData={this.state.facultyInfo}
        />
      </>
    );
  }
}

export default withStyles(styles)(PosterItems);
